var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4312_461)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.77659 17.8763H10.2649C14.7057 17.8763 18.3115 14.3387 18.3115 9.9821C18.3115 5.62547 14.7057 2.08787 10.2649 2.08787",
    fill: "#AA7C00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4878 15.9636L14.0521 15.9822L15.029 14.98L16.5107 14.9575L15.4878 15.965V15.9636Z",
    fill: "#E7BB29"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0293 16.3433L13.5435 16.3605L12.7168 16.8649L14.4285 16.7375L15.0293 16.3433Z",
    fill: "#E7BB29"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5635 6.65573L16.0195 6.56812C15.8612 6.20042 15.2821 5.35086 14.8572 4.88095L16.5107 5.00838C16.8598 5.46104 17.3267 6.19909 17.5635 6.65573Z",
    fill: "#F3E9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.77666 17.8763C4.33266 17.8763 0.730087 14.342 0.730087 9.9821C0.730087 5.62224 4.33266 2.08787 8.77666 2.08787C13.2207 2.08787 16.8232 5.62224 16.8232 9.9821C16.8232 14.342 13.2207 17.8763 8.77666 17.8763Z",
    fill: "#ECD559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.77666 17.8763C4.33266 17.8763 0.730087 14.342 0.730087 9.9821C0.730087 5.62224 4.33266 2.08787 8.77666 2.08787C13.2207 2.08787 16.8232 5.62224 16.8232 9.9821C16.8232 14.342 13.2207 17.8763 8.77666 17.8763Z",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.59328 9.98234C2.82736 3.70226 8.80783 3.38898 8.72124 3.38898C5.01118 3.38898 2.00065 6.34385 2.00065 9.98234C2.00065 13.6208 5.01253 16.5757 8.72124 16.5757C8.80783 16.5757 2.70423 16.2186 2.59328 9.98234Z",
    fill: "#A67705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.77667 16.63C5.03435 16.63 2.00061 13.6537 2.00061 9.98226C2.00061 6.3108 5.03435 3.33449 8.77667 3.33449C12.519 3.33449 15.5527 6.3108 15.5527 9.98226C15.5527 13.6537 12.519 16.63 8.77667 16.63Z",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.77659 17.8763H10.2649C14.7057 17.8763 18.3115 14.3387 18.3115 9.9821C18.3115 5.62547 14.7057 2.08787 10.2649 2.08787",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2651 2.08787H8.77668",
    stroke: "#0B1420",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5054 1.03661C11.136 0.627759 10.3471 0.371565 9.65156 0.56006",
    stroke: "black",
    strokeWidth: 0.78476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25168 1.4028C5.56155 0.948817 6.30714 0.590411 7.02295 0.685986",
    stroke: "black",
    strokeWidth: 0.78476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5018 10.7295C10.5018 10.7295 9.51408 11.303 8.46818 11.2286C7.42227 11.1543 6.48867 10.8198 6.48867 10.8198C6.48867 10.8198 6.30736 12.1286 7.04206 13.3233C7.77677 14.518 8.44517 14.7344 9.13794 14.6202C9.8307 14.506 10.6696 13.7468 10.9551 12.5441C10.4883 12.1233 10.2583 11.36 10.4991 10.7295H10.5018Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5347 10.6953C9.29934 11.3457 7.87593 11.3895 6.45252 10.8997C6.46199 11.2515 6.47688 11.5674 6.54047 11.8926C7.12363 12.4939 9.30204 12.482 10.4427 11.6816C10.3331 11.3643 10.398 11.0789 10.5347 10.6953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.84968 13.8675C8.93628 13.6857 9.06213 13.4574 9.4383 13.3897C9.94167 13.2994 10.3057 13.6472 10.3057 13.6472C10.3057 13.6472 10.035 14.4158 9.07701 14.5512C8.09733 14.6905 7.77664 13.9313 7.77664 13.9313C7.77664 13.9313 7.84565 13.6671 8.17852 13.5224C8.42073 13.4175 8.71978 13.456 8.99988 13.6074",
    fill: "#FF7EB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84968 13.8675C8.93628 13.6857 9.06213 13.4574 9.4383 13.3897C9.94167 13.2994 10.3057 13.6472 10.3057 13.6472C10.3057 13.6472 10.035 14.4158 9.07701 14.5512C8.09733 14.6905 7.77664 13.9313 7.77664 13.9313C7.77664 13.9313 7.84565 13.6671 8.17852 13.5224C8.42073 13.4175 8.71978 13.456 8.99988 13.6074",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2427 9.98241C12.6243 9.52577 11.2969 9.60409 10.7069 10.4032C9.74886 11.6988 11.2806 13.1643 12.3022 13.3873",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5347 10.6952C9.00302 11.5421 7.37395 11.404 5.65828 10.4031",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9614 12.5456C10.7544 13.3872 10.0914 14.5885 8.90073 14.6204C7.10659 14.6695 6.31235 12.0226 6.50043 10.8266",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51291 9.81497C6.45403 9.81497 5.59564 8.75472 5.59564 7.44684C5.59564 6.13895 6.45403 5.0787 7.51291 5.0787C8.57179 5.0787 9.43018 6.13895 9.43018 7.44684C9.43018 8.75472 8.57179 9.81497 7.51291 9.81497Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02539 9.26149C8.84001 9.07698 8.45301 8.72786 7.96858 8.65751C7.40162 8.57521 6.88607 8.75441 6.72369 9.18981C6.5126 9.75795 6.97267 10.4363 7.68578 10.6168C8.02 10.7018 8.41918 10.6872 8.75747 10.5332",
    fill: "#ECD559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.02539 9.26149C8.84001 9.07698 8.45301 8.72786 7.96858 8.65751C7.40162 8.57521 6.88607 8.75441 6.72369 9.18981C6.5126 9.75795 6.97267 10.4363 7.68578 10.6168C8.02 10.7018 8.41918 10.6872 8.75747 10.5332",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2595 9.81497C9.20061 9.81497 8.34222 8.75472 8.34222 7.44684C8.34222 6.13895 9.20061 5.0787 10.2595 5.0787C11.3184 5.0787 12.1768 6.13895 12.1768 7.44684C12.1768 8.75472 11.3184 9.81497 10.2595 9.81497Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1836 6.54169C9.69649 6.54169 9.30002 7.03019 9.30002 7.63284C9.30002 8.2355 9.69514 8.72399 10.1836 8.72399C10.6437 8.72399 10.9915 8.25143 11.0239 7.97267L10.2459 7.6209L11.0104 7.24789C10.9468 6.92001 10.6139 6.54169 10.1836 6.54302V6.54169Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50052 6.36766C7.01338 6.36766 6.61691 6.85615 6.61691 7.45881C6.61691 8.06146 7.01203 8.54996 7.50052 8.54996C7.96059 8.54996 8.30834 8.07739 8.34082 7.79863L7.56276 7.44686L8.32729 7.07385C8.26369 6.74598 7.93082 6.36766 7.50052 6.36899V6.36766Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4312_461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldCoin);
export default __webpack_public_path__ + "static/media/GoldCoin.3e031507bda7d9408154c1bded23d100.svg";
export { ForwardRef as ReactComponent };